import script from "./PublishArticleButton.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublishArticleButton.vue?vue&type=script&lang=js"
export * from "./PublishArticleButton.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublishArticleButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/edit-article-page/elements/PublishArticleButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9404db8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9404db8', __exports__)) {
    api.reload('b9404db8', __exports__)
  }
  
}


export default __exports__